import React from "react";

const style = {
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '1.3',
    textTransform: 'uppercase',
    color: 'variables.$gray_80',
    marginBottom: '15px',
    marginTop: '30px',
}

const NotAvailable = (props) => {
    return (
        <div style={style}>
            <p>Временно недоступно для заказа!</p>
        </div>
    );
}

export default NotAvailable;
